import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=61af96ca&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61af96ca')) {
      api.createRecord('61af96ca', component.options)
    } else {
      api.reload('61af96ca', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=61af96ca&", function () {
      api.rerender('61af96ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I1iWLw9P1ob4/JS/comp/ErrorMessage.vue"
export default component.exports